// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import i18n from './assets/language/i18n'
import './assets/bootstrap/Bootstrap'
// import Carousel3d from 'vue-carousel-3d'
// import VueAgile from 'vue-agile'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import BaiduMap from 'vue-baidu-map'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import locale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import { jcImgScroll } from "@/js/jQuery-jcImgScroll"
import $ from 'jquery'
import router from './router'

// import './assets/styles/css/comment.css'
// import './assets/styles/css/01.bilibili_index.css'
Vue.use(ElementUI, {
  elementZhLocale
})
// Vue.use(jcImgScroll)
Vue.config.productionTip = false
// Vue.use(Carousel3d)
// Vue.use(VueAgile)
Vue.use(VueAwesomeSwiper)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: '1phQa1Tf0DVUXKPIsSP2xfnzxhKSC47d'
})
Vue.use(ElementUI, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App,

    CollapseTransition,
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js